export default __webpack_public_path__ + "scene1_4_bgadef2a.png";